import { Children, useState } from 'react';
import { BlinkDot } from '~/components/BlinkDot';
import ChevronLeft from '~/components/icons/ChevronLeft';
import ChevronRight from '~/components/icons/ChevronRight';

export function BlinkQuotes() {
    return (
        <div
            className="quoteWrapper pt-0 md:pt-64 lg:pt-96"
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
            }}>
            <QuoteCarousel>
                <Quote origin="Eiendomsmegler, Larvik">
                    <div>Folk som ikke bor i området har vist interesse for mine objekter takket være Blink.</div>
                </Quote>
                <Quote origin="Boligselger, Olso">
                    <div>Med Blink treffer jeg målgruppen bedre.</div>
                </Quote>
                <Quote origin="Eiendomsmegler, Oslo">
                    <div>
                        Blink er en kjempefordel, ihvertfall i perioder når kjøperne må vekkes til live slik som nå. Jeg opplever at Blink
                        er veldig bra.
                    </div>
                </Quote>
                <Quote origin="Boligselger, Bærum">
                    <div>Jeg er veldig fornøyd med Blink, det gav masse ekstra klikk og visninger av annonsen da jeg solgte boligen.</div>
                </Quote>
            </QuoteCarousel>
        </div>
    );
}

function QuoteCarousel({ children }: { children: JSX.Element[] }) {
    const [leftAlign, setLeftAlign] = useState('0%');
    const [childIndex, setSelectedChild] = useState(0);
    const [touchXStart, setTouchXStart] = useState(0);

    function navigateToChild(nextChild: number) {
        if (nextChild < 0 || nextChild == children.length) {
            return;
        }
        setLeftAlign(`-${nextChild * 100}%`);
        setSelectedChild(nextChild);
    }

    const navigationDots = Children.map(children, (child, index) => {
        const color = childIndex == index ? 'blue-alt-900' : 'green-400';
        return (
            <div style={{ display: 'inline-block' }} onClick={() => navigateToChild(index)}>
                <BlinkDot backgroundColor={color} marginLeft={8} />
            </div>
        );
    });
    return (
        <div className="quoteCarousel" style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
            <div className="quoteSideNavigation text-blue-alt-900 left-0 bg-green-300 p-14" onClick={() => navigateToChild(childIndex - 1)}>
                <ChevronLeft />
            </div>

            <div
                style={{
                    display: 'flex',
                    flexFlow: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <div style={{ overflow: 'hidden' }}>
                    <div
                        className="quoteCarouselView"
                        onTouchStart={(e) => {
                            setTouchXStart(e.changedTouches.item(0).clientX);
                        }}
                        onTouchEnd={(e) => {
                            const endX = e.changedTouches.item(0).clientX;
                            if (endX - touchXStart < 0) {
                                navigateToChild(childIndex + 1);
                            } else {
                                navigateToChild(childIndex - 1);
                            }
                        }}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            left: leftAlign,
                            position: 'relative',
                            transitionDuration: '200ms',
                        }}>
                        {Children.map(children, (c) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>{c}</div>
                        ))}
                    </div>
                </div>
                <div>{navigationDots}</div>
            </div>
            <div
                className="quoteSideNavigation text-blue-alt-900 bg-green-300 p-14"
                onClick={() => navigateToChild(childIndex < children.length - 1 ? childIndex + 1 : 0)}>
                <ChevronRight />
            </div>
        </div>
    );
}

function Quote({ origin, children }: { origin: string; children: JSX.Element[] | JSX.Element }) {
    return (
        <div className="quoteTextWrapper">
            <div className="text-blue-alt-900 quoteQuote">“</div>
            <div
                className="quoteText"
                style={{
                    paddingTop: '10px',
                }}>
                {children}
                <div style={{ marginTop: '10px', fontSize: 'small', fontWeight: 600 }}>{origin}</div>
            </div>
        </div>
    );
}
